import React, { ReactNode, useState } from "react";
import styled from "styled-components";
import { Item } from "@charty/legend/item/model";
import { useTheme } from "@glossy/theme";
import { AbstractDate, Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import { Serie } from "../models";
import Chart from "./chart";
import Legend from "./legend";

type ChartTooltip = {
  count: number;
  label: string;
  color: string;
  date: AbstractDate;
  total?: number;
};

export interface IProps {
  series: Serie[];
  range: Range;
  locale: Locale;
  onClickItem?: (
    uid: Item["id"],
    range: { from: AbstractDate; to: AbstractDate }
  ) => void;
  onClickLegend?: (uid: Item["id"]) => void;
  tooltip?: (serie: Item, total: number) => ReactNode;
  total?: number;
  className?: string;
  chartTooltip?: (props: ChartTooltip[]) => ReactNode;
  scale?: "linear" | "logarithmic";
  timezone: Timezone;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  displayVolumes?: boolean;
}

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const DoubleTimeChart = ({
  series,
  range,
  locale,
  tooltip,
  total,
  onClickItem,
  onClickLegend,
  className,
  chartTooltip,
  scale = "linear",
  timezone,
  disableAnimation = false,
  isFullscreen,
  displayVolumes,
}: IProps) => {
  const [hovered, setHovered] = useState(null);
  const theme = useTheme();
  return (
    <Root className={className}>
      <Legend
        setHovered={setHovered}
        theme={theme}
        series={series}
        range={range}
        locale={locale}
        tooltip={tooltip}
        total={total}
        onClickLegend={onClickLegend}
        disableAnimation={disableAnimation}
        displayVolumes={displayVolumes}
      />
      <Chart
        series={series}
        range={range}
        locale={locale}
        onClickItem={onClickItem}
        chartTooltip={chartTooltip}
        scale={scale || "linear"}
        theme={theme}
        hovered={hovered}
        timezone={timezone}
        disableAnimation={disableAnimation}
        isFullscreen={isFullscreen}
      />
    </Root>
  );
};

export default DoubleTimeChart;
